import { Dialog, DialogClose, DialogContent, DialogOverlay } from '@weee-fe/kunlun';
import VideoPlayer, { VideoPlayerRef } from './video-player';
import { exitAnyPictureInPicture } from './use-picture-in-picture';
import { XFullBleedOutline } from '@weee-fe/kunlunicon';
import { useEffect, useRef } from 'react';

interface PlayerDialogProps {
  src: string;
  controller: {
    show: () => void;
    hide: () => void;
    visible: boolean;
    setOpen: (open: boolean) => void;
  };
}

const PlayerDialog = ({ src, controller }: PlayerDialogProps) => {
  const videoRef = useRef<VideoPlayerRef>(null);

  useEffect(() => {
    if (controller.visible) {
      // Ensure any previously opened PiP is closed (even from old elements)
      exitAnyPictureInPicture();
    }
  }, [controller.visible]);

  return (
    <Dialog
      aria-label="Hero video player"
      aria-modal="true"
      open={controller.visible}
      onOpenChange={open => {
        if (open) exitAnyPictureInPicture();
        controller.setOpen(open);
      }}>
      <DialogOverlay className="bg-transparent backdrop-blur-none" />
      <DialogContent
        className="flex items-center justify-center w-full h-full max-w-full max-h-full py-[22px] px-[18px] box-border rounded-none bg-tint-black-800"
        onClick={controller.hide}
        {...{
          scrollbyOverlay: false
        }}>
        <VideoPlayer ref={videoRef} src={src} autoPlay muted={false} />
        <DialogClose asChild>
          <div
            role="button"
            tabIndex={0}
            aria-label="Close hero video"
            className="absolute bottom-28 landscape:bottom-7 left-1/2 -translate-x-1/2 w-14 h-14 flex items-center justify-center rounded-full border border-reserved-true-white border-solid">
            <XFullBleedOutline className="text-reserved-true-white text-lg" aria-hidden="true" />
          </div>
        </DialogClose>
      </DialogContent>
    </Dialog>
  );
};

export default PlayerDialog;
